export default __webpack_public_path__ + "e49aab0.png";